module.exports = __webpack_public_path__ + "static/media/s_v5_t4.ba5a6107.mp3";